import {
  createApplicationMaterial,
  getApplicationMaterial,
  getApplicationMaterialId,
  deleteApplicationMaterial,
  updateApplicationMaterial,
  updatePatchApplicationMaterial,
  deleteMaterialInside,


  createApplicationInstrument,
  createApplicationInstrumentMovement,
  getApplicationInstrument,
  deleteApplicationInstrument,
  getApplicationInstrumentId,
  updateApplicationInstrument,
  updatePatchApplicationInstrument,
  deleteInstrumentInside,
 

  createApplicationTransport,
  getApplicationTransport,
  deleteApplicationTransport,
  getApplicationTransportId,
  updateApplicationTransport,
  updatePatchApplicationTransport,
  deleteTransportInside,


  getApplicationStatus,
  getApplicationAuthor,
  getApplicationType,
  getApplicationTimeLine,
  getApplicationTimeLineById,



  createApplicationMovement,
  getApplicationMovement,
  getApplicationInstrumentMovement,
  updateApplicationInstrumentMovement,
  updateApplicationMovement,
  getOneApplicationMovement,
  deleteApplicationMovement,
  getOneApplicationInstrumentMovement,
  deleteApplicationInstrumentMovement,
  createApplicationMovementForInstrument,


  getApplicationGoodReturn,
  getOneApplicationGoodReturn,
  createApplicationGoodReturn,
  createApplicationInstrumentReturn,
  getApplicationInstrumentReturn,
  getOneApplicationInstrumentReturn,
  updateApplicationInstrumentReturn,
  updateApplicationGoodReturn,
  postForGoodReturn,
  postForInstrumentsReturn,
  editForGoodReturn,
  editForInstrumentsReturn,




  getApplicationForBrigadeWorks,
  createApplicationForBrigadeWorks,
  getOneApplicationForBrigadeWorks,
  updatePutApplicationForBrigadeWorks,
  updatePatchApplicationForBrigadeWorks,
  deleteApplicationForBrigadeWorks,




  getPartialPaymentForBrigade,
  createPartialPaymentForBrigade,
  getOnePartialPaymentForBrigade,
  updatePutPartialPaymentForBrigade,
  updatePatchPartialPaymentForBrigade,
  deletePartialPaymentForBrigade,




  reportRequirementForBrigade,
  reportRequirementForBrigadeByWorkCategory,
  reportRequirementForBrigadeByWorkType,
  reportRequirementForGood,
  reportRequirementForGoodMaterialType,


  getWorkerWriteOffForGood,
  getWorkerWriteOffForInstrument,



} from '@/api/application'

export default {

  POST_FOR_GOOD_RETURN({ commit }, data) {
    return postForGoodReturn(data)
      .then(res => {
        return res.data
      })
  },

  EDIT_FOR_GOOD_RETURN({ commit }, data) {
    return editForGoodReturn(data)
      .then(res => {
        return res.data
      })
  },

  EDIT_FOR_INSTRUMENTS_RETURN({ commit }, data) {
    return editForInstrumentsReturn(data)
      .then(res => {
        return res.data
      })
  },


  POST_FOR_INSTRUMENTS_RETURN({ commit }, data) {
    return postForInstrumentsReturn(data)
      .then(res => {
        return res.data
      })
  },











  CREATE_APPLICATIONS_MATERIAL(_, data) {
    return createApplicationMaterial(data)
  },

  FETCH_APPLICATIONS_MATERIAL({ commit }, params) {
    return new Promise((resolve, reject) => {
      getApplicationMaterial(params)
        .then(res => {
          commit('SET_APPLICATIONS_MATERIAL', res.data)
          commit('SET_APPLICATION_PURCHASE', res.data)
          resolve(res.data)
        })
        .catch(e => {
          reject(e)
        })
    })
  },

  DELETE_APPLICATION_MATERIAL(_, id) {
    return deleteApplicationMaterial(id)
  },

  UPDATE_APPLICATION_MATERIAL(_, data) {
    return updateApplicationMaterial(data)
  },
  
  UPDATE_PATCH_APPLICATION_MATERIAL(_, data) {
    return updatePatchApplicationMaterial(data)
  },

  FETCH_APPLICATIONS_MATERIAL_ID({ commit }, params) {
    return getApplicationMaterialId(params)
      .then(res => {
        commit('SET_APPLICATIONS_MATERIAL_ID', res.data)
      })
  },

  DELETE_MATERIAL_INSIDE(_, id) {
    return deleteMaterialInside(id)
  },













  CREATE_APPLICATION_INSTRUMENT(_, data) {
    return createApplicationInstrument(data)
  },

  FETCH_APPLICATION_INSTRUMENT({ commit }, params) {
    return new Promise((resolve, reject) => {
      getApplicationInstrument(params)
        .then(res => {
          commit('SET_APPLICATION_INSTRUMENT', res.data)
          commit('SET_APPLICATION_PURCHASE', res.data)
          resolve(res.data)
        })
        .catch(e => {
          reject(e)
        })
    })
  },

  DELETE_APPLICATION_INSTRUMENT(_, id) {
    return deleteApplicationInstrument(id)
  },

  FETCH_APPLICATIONS_INSTRUMENT_ID({ commit }, params) {
    return getApplicationInstrumentId(params)
      .then(res => {
        commit('SET_APPLICATIONS_INSTRUMENT_ID', res.data)
      })
  },

  UPDATE_APPLICATION_INSTRUMENT(_, data) {
    return updateApplicationInstrument(data)
  },
  UPDATE_PATCH_APPLICATION_INSTRUMENT(_, data) {
    return updatePatchApplicationInstrument(data)
  },

  DELETE_INSTRUMENT_INSIDE(_, id) {
    return deleteInstrumentInside(id)
  },







  CREATE_APPLICATION_TRANSPORT(_, data) {
    return createApplicationTransport(data)
  },

  FETCH_APPLICATION_TRANSPORT({ commit }, params) {
    return new Promise((resolve, reject) => {
      getApplicationTransport(params)
        .then(res => {
          commit('SET_APPLICATION_TRANSPORT', res.data)
          resolve(res.data)
        })
        .catch(e => {
          reject(e)
        })
    })
  },

  DELETE_APPLICATION_TRANSPORT(_, id) {
    return deleteApplicationTransport(id)
  },

  FETCH_APPLICATIONS_TRANSPORT_ID({ commit }, params) {
    return getApplicationTransportId(params)
      .then(res => {
        commit('SET_APPLICATIONS_TRANSPORT_ID', res.data)
      })
  },

  UPDATE_APPLICATION_TRANSPORT(_, data) {
    return updateApplicationTransport(data)
  },
  
  UPDATE_PATCH_APPLICATION_TRANSPORT(_, data) {
    return updatePatchApplicationTransport(data)
  },

  DELETE_TRANSPORT_INSIDE(_, id) {
    return deleteTransportInside(id)
  },













  FETCH_APPLICATION_STATUS({ commit }, params) {
    return getApplicationStatus(params)
      .then(res => {
        commit('SET_APPLICATION_STATUS', res.data)
      })
  },

  FETCH_APPLICATION_AUTHOR({ commit }, params) {
    return getApplicationAuthor(params)
      .then(res => {
        commit('SET_APPLICATION_USER', res.data)
      })
  },

  FETCH_APPLICATION_TYPE({ commit }, params) {
    return getApplicationType(params)
      .then(res => {
        commit('SET_APPLICATION_TYPE', res.data)
      })
  },
  FETCH_APPLICATION_STATUS_TIMELINE({ commit }, payload) {
    return new Promise((reslove, reject) => {
      getApplicationTimeLine(payload)
        .then(res => {
          commit('SET_APPLICATION_STATUS_TIMELINE', res.data)
          reslove(res.data)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  FETCH_APPLICATION_STATUS_TIMELINE_BY_ID({ commit }, payload) {
    return new Promise((reslove, reject) => {
      getApplicationTimeLineById(payload)
        .then(res => {
          commit('SET_APPLICATION_STATUS_TIMELINE_BY_ID', res.data)
          reslove(res.data)
        })
        .catch(error => {
          reject(error)
        })
    })
  },









  CREATE_APPLICATION_MOVEMENT(_, data) {
    return createApplicationMovement(data)
  },
  CREATE_APPLICATION_MOVEMENT_FOR_INSTRUMENT(_, data) {
    return createApplicationMovementForInstrument(data)
  },
  UPDATE_APPLICATION_MATERIAL_MOVEMENT(_, data) {
    return updateApplicationMovement(data)
  },
  DELETE_APPLICATION_MOVEMENT(_, data) {
    return deleteApplicationMovement(data)
  },
  FETCH_ONE_APPLICATION_MOVEMENT(_, id) {
    return new Promise((reslove, reject) => {
      getOneApplicationMovement(id)
        .then(res => {
          // commit('SET_APPLICATION_MOVEMENT', res.data)
          reslove(res.data)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  FETCH_APPLICATION_MATERIAL_MOVEMENT({ commit }, data) {
    return new Promise((reslove, reject) => {
      getApplicationMovement(data)
        .then(res => {
          commit('SET_APPLICATION_MATERIAL_MOVEMENT', res.data)
          reslove(res.data)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  CREATE_APPLICATION_INSTRUMENT_MOVEMENT(_, data) {
    return createApplicationInstrumentMovement(data)
  },
  UPDATE_APPLICATION_INSTRUMENT_MOVEMENT(_, data) {
    return updateApplicationInstrumentMovement(data)
  },
  DELETE_APPLICATION_INSTRUMENT_MOVEMENT(_, data) {
    return deleteApplicationInstrumentMovement(data)
  },
  FETCH_APPLICATION_INSTRUMENT_MOVEMENT({ commit }, data) {
    return new Promise((reslove, reject) => {
      getApplicationInstrumentMovement(data)
        .then(res => {
          commit('SET_APPLICATION_INSTRUMENT_MOVEMENT', res.data)
          reslove(res.data)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  FETCH_ONE_APPLICATION_INSTRUMENT_MOVEMENT({ commit }, data) {
    return new Promise((reslove, reject) => {
      getOneApplicationInstrumentMovement(data)
        .then(res => {
          commit('SET_APPLICATION_MATERIAL_MOVEMENT', res.data)
          reslove(res.data)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  FETCH_APPLICATION_GOOD_RETURN({ commit }, data) {
    return new Promise((reslove, reject) => {
      getApplicationGoodReturn(data)
        .then(res => {
          commit('SET_APPLICATIONS_GOOD_RETURN', res.data)
          reslove(res.data)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  FETCH_ONE_APPLICATION_GOOD_RETURN({ commit }, data) {
    return new Promise((reslove, reject) => {
      getOneApplicationGoodReturn(data)
        .then(res => {
          // commit('SET_ONE_APPLICATION_GOOD_RETURN', res.data)
          reslove(res.data)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  CREATE_APPLICATION_GOOD_RETURN(_, data) {
    return createApplicationGoodReturn(data)
  },
  // fetch application instrument return list
  FETCH_APPLICATION_INSTRUMENT_RETURN({ commit }, data) {
    return new Promise((reslove, reject) => {
      getApplicationInstrumentReturn(data)
        .then(res => {
          commit('SET_APPLICATION_INSTRUMENT_RETURN', res.data)
          reslove(res.data)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  FETCH_ONE_APPLICATION_INSTRUMENT_RETURN({ commit }, data) {
    return new Promise((reslove, reject) => {
      getOneApplicationInstrumentReturn(data)
        .then(res => {
          // commit('SET_APPLICATION_INSTRUMENT_RETURN', res.data)
          console.log(res)
          reslove(res.data)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  // create application instrument return
  CREATE_APPLICATION_INSTRUMENT_RETURN(_, data) {
    return createApplicationInstrumentReturn(data)
  },
  // update application instrument return
  UPDATE_APPLICATION_INSTRUMENT_RETURN(_, data) {
    return updateApplicationInstrumentReturn(data)
  },
  // update application good return
  UPDATE_APPLICATION_GOOD_RETURN(_, data) {
    return updateApplicationGoodReturn(data)
  },










  
  FETCH_APPLICATION_FOR_BRIGADE_WORKS({ commit }, data) {
    return new Promise((reslove, reject) => {
      getApplicationForBrigadeWorks(data)
        .then(res => {
          commit('SET_APPLICATION_FOR_BRIGADE_WORKS', res.data)
          reslove(res.data)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  FETCH_ONE_APPLICATION_FOR_BRIGADE_WORKS({ commit }, data) {
    return new Promise((reslove, reject) => {
      getOneApplicationForBrigadeWorks(data)
        .then(res => {
          commit('SET_ONE_APPLICATION_FOR_BRIGADE_WORKS', res.data)
          reslove(res.data)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  
  CREATE_PATCH_APPLICATION_FOR_BRIGADE_WORKS(_, data) {
    return createApplicationForBrigadeWorks(data)
  },
  
  UPDATE_PUT_APPLICATION_FOR_BRIGADE_WORKS(_, data) {
    return updatePutApplicationForBrigadeWorks(data)
  },
  
  UPDATE_PATCH_APPLICATION_FOR_BRIGADE_WORKS(_, data) {
    return updatePatchApplicationForBrigadeWorks(data)
  },
  DELETE_APPLICATION_FOR_BRIGADE_WORKS(_, data) {
    return deleteApplicationForBrigadeWorks(data)
  },


  













  
  FETCH_PARTIAL_PAYMENTS_FOR_BRIGADE_WORKS({ commit }, data) {
    return new Promise((reslove, reject) => {
      getPartialPaymentForBrigade(data)
        .then(res => {
          commit('SET_PARTIAL_PAYMENTS_FOR_BRIGADE_WORKS', res.data)
          reslove(res.data)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  FETCH_ONE_PARTIAL_PAYMENTS_FOR_BRIGADE_WORKS({ commit }, data) {
    return new Promise((reslove, reject) => {
      getOnePartialPaymentForBrigade(data)
        .then(res => {
          commit('SET_ONE_PARTIAL_PAYMENTS_FOR_BRIGADE_WORKS', res.data)
          reslove(res.data)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  
  CREATE_PATCH_PARTIAL_PAYMENTS_FOR_BRIGADE_WORKS(_, data) {
    return createPartialPaymentForBrigade(data)
  },
  
  UPDATE_PUT_PARTIAL_PAYMENTS_FOR_BRIGADE_WORKS(_, data) {
    return updatePutPartialPaymentForBrigade(data)
  },
  
  UPDATE_PATCH_PARTIAL_PAYMENTS_FOR_BRIGADE_WORKS(_, data) {
    return updatePatchPartialPaymentForBrigade(data)
  },
  DELETE_PARTIAL_PAYMENTS_FOR_BRIGADE_WORKS(_, data) {
    return deletePartialPaymentForBrigade(data)
  },



















  FETCH_REPORT_REQUIREMENT_FOR_BRIGADE({ commit }, data) {
    return new Promise((reslove, reject) => {
      reportRequirementForBrigade(data)
        .then(res => {
          commit('SET_REPORT_REQUIREMENT_FOR_BRIGADE', res.data)
          reslove(res.data)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  FETCH_REPORT_REQUIREMENT_FOR_BRIGADE_BY_WORK_CATEGORY({ commit }, data) {
    return new Promise((reslove, reject) => {
      reportRequirementForBrigadeByWorkCategory(data)
        .then(res => {
          commit('SET_REPORT_REQUIREMENT_FOR_BRIGADE_BY_WORK_CATEGORY', res.data)
          reslove(res.data)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  FETCH_REPORT_REQUIREMENT_FOR_BRIGADE_BY_WORK_TYPE({ commit }, data) {
    return new Promise((reslove, reject) => {
      reportRequirementForBrigadeByWorkType(data)
        .then(res => {
          commit('SET_REPORT_REQUIREMENT_FOR_BRIGADE_BY_WORK_TYPE', res.data)
          reslove(res.data)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  FETCH_REPORT_REQUIREMENT_FOR_GOOD({ commit }, data) {
    return new Promise((reslove, reject) => {
      reportRequirementForGood(data)
        .then(res => {
          commit('SET_REPORT_REQUIREMENT_FOR_GOOD', res.data)
          reslove(res.data)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  FETCH_REPORT_REQUIREMENT_FOR_GOOD_MATERIAL_TYPE({ commit }, data) {
    return new Promise((reslove, reject) => {
      reportRequirementForGoodMaterialType(data)
        .then(res => {
          commit('SET_REPORT_REQUIREMENT_FOR_GOOD_MATERIAL_TYPE', res.data)
          reslove(res.data)
        })
        .catch(error => {
          reject(error)
        })
    })
  },














  FETCH_WORKER_WRITE_OFF_FOR_GOOD({ commit }, data) {
    return new Promise((reslove, reject) => {
      getWorkerWriteOffForGood(data)
        .then(res => {
          commit('SET_WORKER_WRITE_OFF_FOR_GOOD', res.data)
          reslove(res.data)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  FETCH_WORKER_WRITE_OFF_FOR_INSTRUMENT({ commit }, data) {
    return new Promise((reslove, reject) => {
      getWorkerWriteOffForInstrument(data)
        .then(res => {
          commit('SET_WORKER_WRITE_OFF_FOR_INSTRUMENT', res.data)
          reslove(res.data)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  
}
